// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__32aNW","amount":"Amount_amount__1lzgn","tip":"Amount_tip__2rSKZ","tipHeader":"Amount_tipHeader__3W3bE","tipsWrap":"Amount_tipsWrap__2HuCL"};